import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

export const NOTIFICACOES_POR_USUARIO = gql`
  query NotificacoesPorUsuario($page: Int, $size: Int) {
    notificacoesPorUsuario(page: $page, size: $size) {
      page
      size
      totalItems
      totalPages
      items {
        criadoEm
        id
        lida
        mensagem
        referenciaId
        tipo
        tipoDestinatario
        liga {
          id
          nome
        }
        torneio {
          id
          nome
        }
        partida {
          id
        }
        usuarioDestino {
          id
          email
          nome
          username
          imagemUrl
        }
        usuarioAutor {
          id
          email
          nome
          username
          imagemUrl
        }
      }
    }
  }
`;

export interface UsuarioNotificacao {
  id: string;
  email: string;
  nome: string;
  username?: string | null;
  imagemUrl?: string | null;
}

export interface UsuarioAutor {
  id: string;
  email: string;
  nome: string;
  imagemUrl?: string | null;
  username?: string | null;
}

export interface UsuarioDestino {
  id: string;
  email: string;
  nome: string;
  username?: string | null;
  imagemUrl?: string | null;
}

export interface Notificacao {
  id: string;
  criadoEm: string;
  lida: boolean;
  mensagem: string;
  referenciaId?: string | null;
  tipo?: string | null;
  tipoDestinatario?: string | null;
  liga?: { id: string; nome: string } | null;
  torneio?: { id: string; nome: string } | null;
  partida?: { id: string } | null;
  usuarioDestino: UsuarioDestino;
  usuarioAutor?: UsuarioAutor | null;
}

export interface NotificacoesPorUsuarioData {
  notificacoesPorUsuario: {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: Notificacao[];
  };
}

export interface NotificacoesPorUsuarioVars {
  page: number;
  size: number;
}

export const listarNotificacoesPorUsuario = async (
  page: number,
  size: number
) => {
  const { data } = await apolloClient.query<
    NotificacoesPorUsuarioData,
    NotificacoesPorUsuarioVars
  >({
    query: NOTIFICACOES_POR_USUARIO,
    variables: { page, size },
    fetchPolicy: 'no-cache',
  });
  return data.notificacoesPorUsuario;
};

export const MARCAR_NOTIFICACOES_LIDAS = gql`
  mutation MarcarNotificacoesLidas {
    marcarNotificacoesLidas
  }
`;

export interface MarcarNotificacoesLidasData {
  marcarNotificacoesLidas: boolean;
}

export const marcarNotificacoesLidas = async () => {
  const { data } = await apolloClient.mutate<MarcarNotificacoesLidasData>({
    mutation: MARCAR_NOTIFICACOES_LIDAS,
    fetchPolicy: 'no-cache',
  });
  return data?.marcarNotificacoesLidas;
};
